import React, { Component } from "react";
import { Bar } from "react-chartjs-2";

class CommitActivityStats extends Component {
  render() {
    const rand = (min, max, num) => {
      var rtn = [];

      while (rtn.length < num) {
        rtn.push(Math.random() * (max - min) + min);
      }

      return rtn;
    };

    const data = {
      labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
      datasets: [
        {
          label: "Week 1",
          fillColor: "#6892FF",
          strokeColor: "#6892FF",
          backgroundColor: "#6892FF",
          pointColor: "#6892FF",
          pointStrokeColor: "#6892FF",
          pointHighlightFill: "#6892FF",
          pointHighlightStroke: "rgba(220,220,220,1)",
          data: rand(5, 30, 7)
        },
        {
          label: "Week 2",
          fillColor: "#6892FF",
          strokeColor: "#6892FF",
          backgroundColor: "#6892FF",
          pointColor: "#6892FF",
          pointStrokeColor: "#6892FF",
          pointHighlightFill: "#6892FF",
          pointHighlightStroke: "rgba(151,187,205,1)",
          data: rand(5, 30, 7)
        },
        {
          label: "Week 3",
          backgroundColor: "#6892FF",
          fillColor: "#6892FF",
          strokeColor: "#6892FF",
          pointColor: "#6892FF",
          pointStrokeColor: "#6892FF",
          pointHighlightFill: "#6892FF",
          pointHighlightStroke: "rgba(151,187,205,1)",
          data: rand(5, 30, 7)
        },
        {
          label: "Week 4",
          strokeColor: "#6892FF",
          pointColor: "#6892FF",
          backgroundColor: "#6892FF",
          pointStrokeColor: "#6892FF",
          pointHighlightFill: "#6892FF",
          pointHighlightStroke: "rgba(151,187,205,1)",
          data: rand(5, 30, 7)
        }
      ]
    };

    const lineOptions = {
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            }
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              userCallback(value) {
                return value;
              }
            }
          }
        ]
      },
      legend: {
        display: false
      },
      tooltips: {
        enabled: true
      }
    };

    return <Bar data={data} options={lineOptions} />
  }
}

export default CommitActivityStats;
